import { useTranslator } from 'components/shared/hooks';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import { ROUTE_TEMPLATES, ROUTE_TEMPLATES_LIST } from 'config/routes';
import React, { FC, Fragment } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { relativePath } from 'utils/navigation/relativePath';
import { NotFoundView } from 'views/Errors/NotFound.view';
import { TemplatesListView } from 'views/Panel/Templates/TemplatesList/TemplatesList.view';

export const TemplatesView: FC = () => {
  const trans = useTranslator();

  return (
    <Fragment>
      <Breadcrumb label={trans('BREADCRUMB.TEMPLATES.TEMPLATES')} static />

      <Routes>
        <Route
          path={relativePath(ROUTE_TEMPLATES, ROUTE_TEMPLATES)}
          element={<Navigate to={ROUTE_TEMPLATES_LIST} replace />}
        />
        <Route path={relativePath(ROUTE_TEMPLATES_LIST, ROUTE_TEMPLATES)} element={<TemplatesListView />} />
        <Route path="*" element={<NotFoundView />} />
      </Routes>
    </Fragment>
  );
};
